import React, { useRef } from "react";
import styled from "styled-components";
import ReactToPrint from "react-to-print";
import { useHistory } from "react-router-dom";

import Button from "./Button";
import * as Typography from "./Typography";

const SuccessProtocolMsg = ({ protocolId, timestamp }) => {
  const history = useHistory();
  const componentRef = useRef();

  return (
    <Container ref={componentRef}>
      <Backdrop>
        <Header>ENVIO REALIZADO COM SUCESSO!</Header>
        <Separator />
      </Backdrop>
      <Typography.p style={{ textAlign: "center" }}>
        Guarde o número de protocolo gerado pois é imprescindível para o
        acompanhamento do seu relato.
      </Typography.p>
      <Backdrop>
        <Header>
          Número de protocolo: <small>{protocolId}</small>
        </Header>
        <Separator />
      </Backdrop>
      <Typography.p style={{ padding: "0px 27px", textAlign: "center" }}>
        *Lembramos que todas as informações serão tratadas de forma confidencial
        por todos os envolvidos no processo de apuração.
      </Typography.p>
      <ButtonContainer>
        <Button
          variant="contained"
          color="primary"
          onClick={() => history.push("/protocolsearch")}
        >
          Acompanhar Protocolo
        </Button>

        <ReactToPrint
          trigger={() => (
            <Button variant="contained" color="primary">
              IMPRIMIR PROTOCOLO
            </Button>
          )}
          content={() => componentRef.current}
        />
      </ButtonContainer>{" "}
      <Separator />
      <Typography.p>
        Data: {new Date(timestamp).toLocaleDateString()}
      </Typography.p>
    </Container>
  );
};

export default SuccessProtocolMsg;

const Container = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
`;

const Header = styled(Typography.h2)`
  && {
    color: #fff;
    margin: 5px;
  }
`;

const Backdrop = styled(Container)`
  background-color: #0d4f78;
  flex: 1;
`;

const Separator = styled.div`
  margin: 10px 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;
